 /**
#Written by Artem Khachaturov
#adbiq.com
**/

 function calculateHMSleft() {
     d = new Date,
        weekday = new Array(7);
    weekday[0] = "Sun,", weekday[1] = "Mon,", weekday[2] = "Tue,", weekday[3] = "Wed,", weekday[4] = "Thu,", weekday[5] = "Fri,", weekday[6] = "Sat,";
    var monthday = new Array(12);
    monthday[0] = "Jan", monthday[1] = "Feb", monthday[2] = "Mar", monthday[3] = "Apr", monthday[4] = "May", monthday[5] = "Jun", monthday[6] = "Jul", monthday[7] = "Aug", monthday[8] = "Sep", monthday[9] = "Oct", monthday[10] = "No", monthday[11] = "Dec";
    var now = new Date(___current_date),
        hoursleft = now.getHours();
    now.getHours() <= 17 ? hoursleft = 17 - now.getHours() : hoursleft = 24 - hoursleft + 17;
    var minutesleft = 59 - now.getMinutes(),
        secondsleft = 59 - now.getSeconds();
    if (minutesleft < 10 && (minutesleft = "0" + minutesleft), secondsleft < 10 && (secondsleft = "0" + secondsleft), $(".HMSremaining").html(hoursleft + " hrs " + minutesleft + " mins."), document.getElementById("delivery-date-latest") == null) return !1;
    if (hoursleft > 12)
        if (d.getDay() == 0 || d.getDay() <= 2) {
            d.setHours(d.getHours() + 72);
            var deliver = weekday[d.getDay()],
                day = d.getDate(),
                month = monthday[d.getMonth()];
            document.getElementById("delivery-date-latest").innerHTML = deliver + " " + month + " " + day
        } else if (d.getDay() == 3) {
        d.setHours(d.getHours() + 72);
        var deliver = weekday[d.getDay()],
            day = d.getDate(),
            month = monthday[d.getMonth()];
        document.getElementById("delivery-date-latest").innerHTML = deliver + " " + month + " " + day
    } else {
        d.setHours(d.getHours() + 96);
        var deliver = weekday[d.getDay()],
            day = d.getDate(),
            month = monthday[d.getMonth()];
        document.getElementById("delivery-date-latest").innerHTML = deliver + " " + month + "-" + day
    } else if (d.getDay() > 0 || d.getDay() <= 3) {
        d.setHours(d.getHours() + 48);
        var deliver = weekday[d.getDay()],
            day = d.getDate(),
            month = monthday[d.getMonth()];
        document.getElementById("delivery-date-latest").innerHTML = deliver + " " + month + " " + day
    } else if (d.getDay() == 0) {
        d.setHours(d.getHours() + 48);
        var deliver = weekday[d.getDay()],
            day = d.getDate(),
            month = monthday[d.getMonth()];
        document.getElementById("delivery-date-latest").innerHTML = deliver + " " + month + " " + day
    } else {
        d.setHours(d.getHours() + 96);
        var deliver = weekday[d.getDay()],
            day = d.getDate(),
            month = monthday[d.getMonth()];
        document.getElementById("delivery-date-latest").innerHTML = deliver + " " + month + "-" + day
    }
    
    $(".delivery-date-esitmator").fadeIn(100);
}

 


function DiscountHandler() {}

DiscountHandler.prototype.coupons = {
    "65OFF-CRETINOLC":{
        "variants":[48495132639552],
        "discount":0.65,
        "type":"percent"
    }
}

DiscountHandler.prototype.discount = false;
DiscountHandler.prototype.options = {};
DiscountHandler.prototype.getQueryStringParameter = function (param) {
    var queryString = window.location.search.substring(1);
    var params = queryString.split("&");
    for (var i = 0; i < params.length; i++) {
        var pair = params[i].split("=");
        if (pair[0] === param) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
};

DiscountHandler.prototype.setCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

DiscountHandler.prototype.getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

DiscountHandler.prototype.applyDiscountCode = function (discountCode, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/discount/' + discountCode, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            if (xhr.responseURL) {
                 
                callback(true);
            } else {
                callback(false);
            }
        } else {
            if( DiscountHandler.prototype.options?.debug == true)
                console.error('Error applying discount code: ' + xhr.status);
            callback(false);
        }
    };

    xhr.onerror = function () {
        if( DiscountHandler.prototype.options?.debug == true)
            console.error('Request failed');
        callback(false);
    };

    xhr.send();
};

DiscountHandler.prototype.getCartDetails = function (callback) {
    var self = this;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true); 
    xhr.setRequestHeader('Content-Type', 'application/json');
    
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            var cart = JSON.parse(xhr.responseText);
            callback(cart);
        } else {
            if(DiscountHandler.prototype.options == true) 
                console.error('Failed to fetch cart details');
            callback(null);
        }
    };

    xhr.onerror = function () {
        console.error('Request failed');
        callback(null);
    };

    xhr.send();
};

DiscountHandler.prototype.addProductToCart = function (variant_id, quantity, callback) {
    var self = this;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            var cart = JSON.parse(xhr.responseText);
            callback(cart);
        } else {
            if(DiscountHandler.prototype.options == true) 
                console.error('Failed to add product to cart');
            callback(null);
        }
    };

    xhr.onerror = function () {
        if(DiscountHandler.prototype.options == true) 
            console.error('Request failed');
        callback(null);
    };

    var data = JSON.stringify({
        id: variant_id,
        quantity: quantity
    });
    xhr.send(data);
};

DiscountHandler.prototype.renderVisualDiscount = function (callback) {
    var self = this;
    var productFormButtons = document.querySelector('.product-form__buttons');
    
    if (productFormButtons && DiscountHandler.prototype.discount != false &&  
        DiscountHandler.prototype?.discount?.variants.includes(meta?.product?.variants[0]?.id)) {
       
        var firstButton = productFormButtons.querySelector(':scope > button');
        var _regularPrice = document.querySelector('.price__regular');
        var _regularPrice_child = _regularPrice.querySelector(":scope > span");
        var _final_price_placeholder = _regularPrice.querySelector("span.price-item.price-item--regular");
        if(!_final_price_placeholder.hasAttribute('price')) 
                _final_price_placeholder.setAttribute("price",_final_price_placeholder.textContent);
        var _final_currency = _final_price_placeholder.getAttribute("price").replace(/[^$]/g, '');
        var _final_price = parseInt(_final_price_placeholder.getAttribute("price").replace(/[^0-9.]/g, ''));
         
        if(_regularPrice){
            _regularPrice_child.classList.remove("visually-hidden", "visually-hidden--inline");
            _regularPrice_child.textContent = '';
            _regularPrice_child.textContent = _regularPrice.textContent;
            _regularPrice_child.classList.add("strikethrough");
    
            /*MATH FORMULA */
            var savings = (_final_price * DiscountHandler.prototype.discount.discount);
            _final_price = (_final_price - (_final_price * DiscountHandler.prototype.discount.discount)).toFixed(2); 
            _final_price_placeholder.textContent = _final_currency+_final_price;
        }
        
        if (firstButton) {
            var newDiv = document.createElement('div');
            newDiv.textContent = 'ORDER NOW & SAVE $'+savings; 
            newDiv.classList.add("product-form__submit", "button", "button--full-width", "button--primary");
            newDiv.setAttribute("onclick","window.location.href='/cart'");
            newDiv.classList.add("apply-shake");
            productFormButtons.replaceChild(newDiv, firstButton);
        }
            _regularPrice.classList.add("apply-shake");
             setTimeout(function(){
                 _regularPrice.classList.remove("apply-shake");
                  _regularPrice.classList.add("apply-shake");
             }, 4000)
        if(callback) callback(true);
    }
}

DiscountHandler.prototype.init = function (options) {
    var self = this;
    var discountCode = this.getQueryStringParameter('discount');
    if(!discountCode) discountCode =  self.getCookie('discount_code');
  
    DiscountHandler.prototype.discount = DiscountHandler.prototype.coupons[discountCode];
    DiscountHandler.prototype.options = options;

           
  if(!DiscountHandler.prototype?.coupons[discountCode]?.variants.includes(options.variant_id)   ) {
     if(DiscountHandler.prototype.options == true)   console.log('false not found correct item.');
          return false; 
  }
 
    this.getCartDetails(function (cart) {
        var variantInCart = false;

        if (cart && cart.items && cart.items.length > 0) {
        
            for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].variant_id === options.variant_id) {
                    variantInCart = true;
                    if(DiscountHandler.prototype.options == true) 
                        console.log('Variant ' + options.variant_id + ' is already in the cart.');
                    break;
                }
            }
        }
 
        if (!variantInCart) {
            self.addProductToCart(options.variant_id, options.quantity || 1, function (addedItem) {
                if (addedItem) {
                    if(DiscountHandler.prototype.options == true) 
                        console.log('Product added to cart:', addedItem);
                } else {
                    if(DiscountHandler.prototype.options == true) 
                        console.error('Failed to add product to cart.');
                }
            });
        }
 
        if (discountCode) {
            self.applyDiscountCode(discountCode, function (isApplied) {
                if (isApplied) {
                    if(DiscountHandler.prototype.options == true) 
                        console.log('Discount code ' + discountCode + ' applied successfully.');
                    
                    self.setCookie('discount_code', discountCode, 30);  
                    self.getCartDetails(function (cart) {
                        if (cart && cart.discount_applications && cart.discount_applications.length > 0) {
                           if(DiscountHandler.prototype.options == true) 
                            console.log("Discounts applied:", cart.discount_applications);
                            
                            var discountDetails = JSON.stringify(cart.discount_applications);
                            if(DiscountHandler.prototype.options == true) 
                                console.log("Discount details in JSON:", discountDetails);
                        } else {
                           if(DiscountHandler.prototype.options == true) 
                               console.log("No discounts applied to the cart.");
                        }
                    });
                } else {
                    if(DiscountHandler.prototype.options == true) 
                        console.log('Failed to apply discount code.');
                }
            });

            self.renderVisualDiscount()
        }
    });
}; 
document.addEventListener('DOMContentLoaded', function () {
  var discountHandler = new DiscountHandler();
   
  discountHandler.init({
    debug:true,
    variant_id: meta?.product?.variants[0]?.id  
  });

  calculateHMSleft(), setInterval(calculateHMSleft, 3000);
  
});